import React, {useCallback, useMemo, useState} from 'react';

import {useAdminAccessRight} from 'src/hooks/access-rights';
import {AssignSeatModal} from 'src/modules/profile/user/tabs/products/assign-btn/assign-seat-modal';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';


type Props = {
    userId: number,
    accountId: number,
    onAssigned: () => void,
};

export const AssignSeatBtn: React.FC<Props> = ({userId, accountId, onAssigned}) => {
    const [shown, setShown] = useState(false);
    const [busy, setBusy] = useState(false);
    const {canEditUserProducts} = useAdminAccessRight();
    const canAssignSeat = useMemo(() =>
        canEditUserProducts(accountId), [canEditUserProducts, accountId]);

    const onClose = useCallback(() => {
        if (!busy) {
            setShown(false);
        }
    }, [busy]);

    return (
        <>
            {
                canAssignSeat
                    ? (<Button variant="Type.PRIMARY" onClick={() => setShown(true)}>Assign Seat</Button>)
                    : null
            }
            <Dialog
                shown={shown}
                setShown={value => {
                    if (!value) {
                        onClose();
                    }
                }}
                wrapperProps={{style: {width: 700}}}>
                <AssignSeatModal
                    userId={userId}
                    accountId={accountId}
                    onBusyChange={setBusy}
                    onClose={onClose}
                    onAssigned={onAssigned}
                />
            </Dialog>
        </>
    );
};
